import { useStyles } from './useStyles';
import { SiteProcessListView } from '../../components/parts/process/ProcessListView';
import {
  Button,
  Grid,
  IconButton,
  Popover,
  Typography
} from '@material-ui/core';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { EditButton, LinkButton } from '../../components/atoms/Button';
import { useHooks } from './useHooks';
import { SITE_PROCESS_DISPLAY_MODE } from '../../const/ProcessConst';
import { SiteProcessAddModal } from '../../components/parts/process/ProcessAddModal';
import ViewListIcon from '@material-ui/icons/ViewList';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import { SiteProcessHistoryModal } from '../../components/parts/process/ProcessHistoryModal';
import { SiteProcessGanttView } from '../../components/parts/process/ProcessGanttView';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { SiteProcessSelectfield } from '../../components/parts/input/ProcessSelectfield';
import { FormProvider, UseFormReturn, useForm } from 'react-hook-form';
import BasePageLayoutWrapper from '../../components/parts/common/BasePageLayoutWrapper';
import { EmptySiteProcessView } from '../../components/parts/process/EmptyProcessView';
import { MoreVert } from '@material-ui/icons';
import LoadingIcon from '../../components/atoms/LoadingIcon';
import LoadingIconClear from '../../components/atoms/LoadingIconClear';
import { useRecoilState } from 'recoil';
import { userMenuId } from '../../GlobalState';
import { AuthInfoContext } from '../../AuthContextProvider';
import { ROLE } from '../../const/Const';
import { TSelectItem } from '../../types/common';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export type TSiteProcessPageForm = {
  construct_id: { value: number; label: string };
};

export const SiteProcessPage: React.FC = () => {
  const classes = useStyles();
  const [userMenu, setUserMenu] = useRecoilState<any>(userMenuId);
  const [createAnchorEl, setCreateAnchorEl] =
    useState<null | HTMLElement>(null);
  const isCreateMenuOpen = Boolean(createAnchorEl);

  const handleClickCreateIcon = (event: React.MouseEvent<SVGSVGElement>) => {
    setCreateAnchorEl(event.currentTarget as unknown as HTMLElement);
  };

  const handleCloseCreateMenu = () => {
    setCreateAnchorEl(null);
  };

  // hook-formの初期設定
  const methods: UseFormReturn<TSiteProcessPageForm> = useForm();
  const { getValues } = methods;
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);
  //プルダウンで表示する選択肢
  const [filteredConstructList, setFilteredConstructList] = useState<
    TSelectItem[]
  >([]);

  const {
    constructList,
    constructListVal,
    constructId,
    renderCurrentConstructView,
    currentPage,
    setCurrentPage,
    lastUpdate,
    displayMode,
    handleOnClickGantt,
    handleOnClickList,
    handleOnClickHistory,
    isOpenAdd,
    setIsOpenAdd,
    handleOnClickAdd,
    siteTaskCounts,
    isOpenSiteProcessHistory,
    setIsOpenSiteProcessHistory,
    handleOnClickExportExcel,
    renderSiteProcessDataTrigger,
    reRenderSiteProcessData,
    setGanttFromTo,
    constructStartDay,
    constructEndDay,
    customerName,
    isOpenAddOfGantt,
    setIsOpenAddOfGantt,
    parentSiteProcessIdOfGanttAdd,
    setParentSiteProcessIdOfGanttAdd,
    handleOnClickAddOfGantt,
    hasSiteProcess,
    hasExpectedDays,
    setHasExpectedDays,
    setHasSiteProcess,
    totalSiteProcessDays,
    anchorEl,
    handleClickMoreVert,
    handleClosePopover,
    isOpenPopover,
    popoverId,
    isSearching,
    isDownloading,
    isLoadingGantt,
    setIsLoadingGantt,
    isOpenCopy,
    setIsOpenCopy,
    handleOnClickCopy,
    isOpenEditPeriod,
    setIsOpenEditPeriod,
    handleOnClickEditPeriod,
    isOpenAllDelete,
    setIsOpenAllDelete,
    handleOnClickAllDelete
  } = useHooks({ getValues });
  //デフォルト値以外を選択肢として取得する(初回レンダリングのみ)
  useEffect(() => {
    setFilteredConstructList(constructList.filter(item => item.value !== 0));
  }, [constructList]);

  //セレクトボックスに用いるリスト修正(再レンダリング時)
  useEffect(() => {
    setFilteredConstructList(
      filteredConstructList.map(item => {
        if (item.value === constructId) {
          return {
            ...item,
            hasProcess: hasSiteProcess // プルダウンのカテゴリを上書き
          };
        }
        return item;
      })
    );
  }, [constructId, hasSiteProcess]);

  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <BasePageLayoutWrapper patternName='site_processes'>
      <div className={classes.containerPadding}>
        {isDownloading && (
          <div className={classes.loadingIconClearWrapper}>
            <LoadingIconClear />
          </div>
        )}
        <Grid
          container
          className={`${classes.gridContainerPadding} ${classes.gridContainerBackgroundColor}`}
        >
          <Grid
            item
            xs={12}
            sm={3}
            className={`${classes.gridFirstRow} ${classes.flexWrap} ${classes.alignFlexStart}`}
          >
            {/* 案件選択 */}
            <FormProvider {...methods}>
              <SiteProcessSelectfield
                name='construct_id'
                label='案件'
                listDatas={filteredConstructList}
                value={constructListVal}
                onChange={renderCurrentConstructView}
                sortHasProcess={true}
                errorMessage={
                  constructId === 0 ? 'まず案件を選択してください' : ''
                }
                className={classes.ProcessSelectfieldWidth}
              />
            </FormProvider>
            {/* /案件選択 */}
            {!isSmDownScreen && (
              <>
                {constructId > 0 && (
                  <IconButton
                    className={classes.moreVert}
                    onClick={handleClickMoreVert}
                  >
                    <MoreVert />
                  </IconButton>
                )}
              </>
            )}
          </Grid>

          {/* 基本レイアウト */}
          {isSmDownScreen && (
            <>
              {constructId > 0 && (
                <Grid
                  item
                  xs={12}
                  sm={9}
                  className={`${classes.textAlignRight} ${classes.flexWrap} ${classes.gridFirstRow}`}
                >
                  {lastUpdate.at !== '' && (
                    <div className={classes.flexWrap}>
                      <div>{`最終更新：${lastUpdate.at} (${lastUpdate.by})`}</div>
                      <div className={classes.firstRowRight}>
                        <Button
                          className={classes.underLine}
                          onClick={handleOnClickHistory}
                        >
                          更新履歴
                        </Button>
                      </div>
                    </div>
                  )}
                  <div
                    className={`${classes.flexWrap} ${classes.constructDateWrapper}`}
                  >
                    <Grid container direction='row' justify='flex-end'>
                      <div className={classes.flexWrap}>
                        <div
                          className={`${classes.constructDateCell} ${classes.constructDateTitleCell}`}
                        >
                          総工事日数
                        </div>
                        <div
                          className={`${classes.constructDateCell} ${classes.constructTotalDaysLabel} ${classes.constructDateCellEnd}`}
                        >
                          {totalSiteProcessDays
                            ? totalSiteProcessDays + '日'
                            : '--'}
                        </div>
                      </div>
                      <div className={classes.flexWrap}>
                        <div
                          className={`${classes.constructDateCell} ${classes.constructDateTitleCell}`}
                        >
                          着工日
                        </div>
                        <div
                          className={`${classes.constructDateCell} ${classes.constructDateLabel} ${classes.constructDateCellEnd}`}
                        >
                          {constructStartDay}
                        </div>
                      </div>
                      <div className={classes.flexWrap}>
                        <div
                          className={`${classes.constructDateCell} ${classes.constructDateTitleCell}`}
                        >
                          竣工日
                        </div>
                        <div
                          className={`${classes.constructDateCell} ${classes.constructDateLabel} ${classes.constructDateCellEnd}`}
                        >
                          {constructEndDay}
                        </div>
                      </div>
                    </Grid>
                  </div>
                </Grid>
              )}
              <Grid item sm={3}>
                <div>{customerName}</div>
              </Grid>
              {constructId > 0 && (
                <>
                  <Grid item sm={9}>
                    <div className={classes.buttonsContainer}>
                      <div
                        className={`${classes.flexWrap} ${classes.justifyRight}`}
                      >
                        <div
                          className={`${classes.firstRowRight} ${classes.leftSideButtonsContainer}`}
                        >
                          {hasSiteProcess && (
                            <>
                              <div
                                className={`${classes.inlineButton} ${classes.inlineButtonAdjust}`}
                              >
                                <EditButton
                                  onClick={handleOnClickExportExcel}
                                  className={classes.excelButton}
                                >
                                  Excel出力
                                </EditButton>
                              </div>
                              <div className={classes.buttonsBorderLine} />
                            </>
                          )}
                        </div>
                        <div className={classes.inlineButton}>
                          <LinkButton
                            to={{
                              pathname: `/constructions/${constructId}/edit`,
                              state: {
                                state: constructId
                              }
                            }}
                          >
                            工事詳細
                          </LinkButton>
                        </div>
                        {userMenu != 'BM' && (
                          <>
                            {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                              <div className={classes.inlineButton}>
                                <LinkButton
                                  to={{
                                    pathname: '/files',
                                    state: {
                                      state: {
                                        id: constructId,
                                        name: constructListVal.label
                                      }
                                    }
                                  }}
                                >
                                  資料一覧
                                </LinkButton>
                              </div>
                            )}
                            <div className={classes.inlineButton}>
                              <LinkButton
                                to={{
                                  pathname: '/pictures',
                                  state: {
                                    state: {
                                      id: constructId,
                                      name: constructListVal.label
                                    }
                                  }
                                }}
                              >
                                写真一覧
                              </LinkButton>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </Grid>
                  <Grid item sm={12}>
                    <hr />
                  </Grid>
                  {(hasExpectedDays || hasSiteProcess) && (
                    <>
                      <Grid item sm={6} className={classes.flexWrap}>
                        {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                          <>
                            <div className={classes.taskCountsLeft}>
                              {`登録タスク: ${siteTaskCounts.task}件 (未完了: ${siteTaskCounts.uncomplete}件)`}
                            </div>
                            <div>{`アラート: ${siteTaskCounts.alert}件`}</div>
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        className={`${classes.textAlignRight} ${classes.flexWrap}`}
                      >
                        {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                          <>
                            {/* 工程の追加ボタン */}
                            {displayMode === SITE_PROCESS_DISPLAY_MODE.list && (
                              <div>
                                <EditButton onClick={handleOnClickAdd}>
                                  工程の追加
                                </EditButton>
                              </div>
                            )}
                            {displayMode ===
                              SITE_PROCESS_DISPLAY_MODE.gantt && (
                              <>
                                {!hasSiteProcess && (
                                  <div
                                    className={
                                      isLoadingGantt
                                        ? classes.disabledAddButton
                                        : ''
                                    }
                                  >
                                    <EditButton onClick={handleOnClickCopy}>
                                      既存の工程表をコピー
                                    </EditButton>
                                  </div>
                                )}
                                <div
                                  className={
                                    isLoadingGantt
                                      ? classes.disabledAddButton
                                      : ''
                                  }
                                >
                                  <EditButton onClick={handleOnClickAddOfGantt}>
                                    工程の追加
                                  </EditButton>
                                </div>
                                <div
                                  className={
                                    isLoadingGantt
                                      ? classes.disabledAddButton
                                      : ''
                                  }
                                >
                                  <EditButton onClick={handleOnClickEditPeriod}>
                                    工事期間編集
                                  </EditButton>
                                </div>
                                {hasSiteProcess && (
                                  <div
                                    className={
                                      isLoadingGantt
                                        ? classes.disabledAddButton
                                        : ''
                                    }
                                  >
                                    <EditButton
                                      onClick={handleOnClickAllDelete}
                                      className={classes.deleteButton}
                                    >
                                      工程全削除
                                    </EditButton>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )}
                        {displayMode === SITE_PROCESS_DISPLAY_MODE.list && (
                          <div>
                            <Button
                              className={classes.underLine}
                              onClick={handleOnClickGantt}
                            >
                              <InsertChartIcon
                                className={classes.InsertChartIconTransform}
                              />
                              ガントチャート形式で表示
                            </Button>
                          </div>
                        )}
                        {displayMode === SITE_PROCESS_DISPLAY_MODE.gantt && (
                          <div>
                            <Button
                              className={classes.underLine}
                              onClick={handleOnClickList}
                            >
                              <ViewListIcon />
                              リスト形式で表示
                            </Button>
                          </div>
                        )}
                      </Grid>
                    </>
                  )}
                </>
              )}
            </>
          )}
          {/* /基本レイアウト */}

          {/* レスポンシブレイアウト */}
          {constructId > 0 && (
            <>
              {!isSmDownScreen && (
                <>
                  <div style={{ width: '100%' }}>
                    {lastUpdate.at !== '' && (
                      <div className={classes.updateDateResponsive}>
                        <div>{`最終更新：${lastUpdate.at} (${lastUpdate.by})`}</div>
                      </div>
                    )}
                    <div
                      className={`${classes.constructDateCellMobileContainer}`}
                    >
                      <div
                        className={`${classes.constructDateCellMobile} ${classes.constructTotalDaysMoblie}`}
                      >
                        総工事日数
                        <br />
                        {totalSiteProcessDays}日
                      </div>
                      <div
                        className={`${classes.constructDateCellMobile} ${classes.constructDateMobile}`}
                      >
                        着工日
                        <br />
                        {constructStartDay}
                      </div>
                      <div
                        className={`${classes.constructDateCellMobile} ${classes.constructDateMobile} ${classes.constructDateCellEnd}`}
                      >
                        竣工日
                        <br />
                        {constructEndDay}
                      </div>
                    </div>
                    <div className={classes.customerNameMoblie}>
                      {customerName}
                    </div>
                  </div>
                  {/* 登録タスク＆アラート */}
                  {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <>
                      <div className={classes.taskAlertWrapper}>
                        <Typography
                          variant='subtitle2'
                          className={classes.textInfoWrapper}
                        >
                          {`登録タスク: ${siteTaskCounts.task}件 (未完了: ${siteTaskCounts.uncomplete}件)`}
                        </Typography>
                        <Typography
                          variant='subtitle2'
                          className={classes.textInfoWrapper}
                        >{`アラート: ${siteTaskCounts.alert}件`}</Typography>
                      </div>
                    </>
                  )}

                  <div className={classes.buttonsContainerForMobile}>
                    <div className={classes.displayModeButtonWrapper}>
                      {/* リストorガント表示切替 */}
                      {displayMode === SITE_PROCESS_DISPLAY_MODE.list && (
                        <div>
                          <Button
                            className={classes.underLine}
                            onClick={handleOnClickGantt}
                          >
                            <InsertChartIcon
                              className={classes.InsertChartIconTransform}
                            />
                            ガントチャート形式で表示
                          </Button>
                        </div>
                      )}
                      {displayMode === SITE_PROCESS_DISPLAY_MODE.gantt && (
                        <div>
                          <Button
                            className={classes.underLine}
                            onClick={handleOnClickList}
                          >
                            <ViewListIcon />
                            リスト形式で表示
                          </Button>
                        </div>
                      )}
                    </div>
                    <div
                      className={`${classes.displayIconButtonWrapper} ${classes.textAlignRight}`}
                    >
                      {/* エクセル出力ボタン */}
                      {/*
                        <div className={classes.buttonWrapper}>
                          <div
                            className={classes.iconContainer}
                            onClick={handleOnClickExportExcel}
                          >
                            <InsertDriveFileIcon
                              className={classes.insertDriveFileIcon}
                            />
                            <ForwardIcon className={classes.forwardIcon} />
                          </div>
                        </div>
                      */}
                      {/* 工程の追加ボタン */}
                      {displayMode === SITE_PROCESS_DISPLAY_MODE.list && (
                        <div className={classes.buttonWrapper}>
                          <CreateNewFolderIcon
                            onClick={handleOnClickAdd}
                            className={classes.createNewFolderIcon}
                          />
                        </div>
                      )}
                      {displayMode === SITE_PROCESS_DISPLAY_MODE.gantt && (
                        <div
                          className={`${classes.buttonWrapper} ${
                            isLoadingGantt ? classes.disabledAddButton : ''
                          }`}
                        >
                          <DashboardIcon
                            onClick={handleClickCreateIcon}
                            className={classes.createNewFolderIcon}
                            fontSize='large'
                          />
                          <Popover
                            open={isCreateMenuOpen}
                            anchorEl={createAnchorEl}
                            onClose={handleCloseCreateMenu}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                padding: 8
                              }}
                            >
                              <Button
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => {
                                  handleOnClickAddOfGantt();
                                  handleCloseCreateMenu();
                                }}
                                style={{ justifyContent: 'flex-start' }}
                              >
                                工程の追加
                              </Button>
                              {!hasSiteProcess && (
                                <Button
                                  startIcon={<ContentCopyIcon />}
                                  onClick={() => {
                                    handleOnClickCopy();
                                    handleCloseCreateMenu();
                                  }}
                                  style={{ justifyContent: 'flex-start' }}
                                >
                                  既存の工程表をコピー
                                </Button>
                              )}
                              <Button
                                startIcon={<EditCalendarIcon />}
                                onClick={() => {
                                  handleOnClickAddOfGantt();
                                  handleCloseCreateMenu();
                                }}
                                style={{ justifyContent: 'flex-start' }}
                              >
                                工事期間編集
                              </Button>
                              {hasSiteProcess && (
                                <Button
                                  startIcon={<DeleteIcon />} // ← アイコンお好みで
                                  onClick={() => {
                                    handleOnClickAllDelete();
                                    handleCloseCreateMenu();
                                  }}
                                  style={{
                                    justifyContent: 'flex-start',
                                    color: 'red'
                                  }}
                                >
                                  工程全削除
                                </Button>
                              )}
                            </div>
                          </Popover>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {/* 三点リーダーメニュー */}
          <Popover
            id={popoverId}
            open={isOpenPopover}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            <div style={{ width: 120 }}>
              {hasSiteProcess && (
                <>
                  <div className={classes.moreVertMenuBorder}>
                    <Button
                      onClick={() => {
                        handleOnClickHistory();
                        handleClosePopover();
                      }}
                      className={classes.moreVertMenuButton}
                    >
                      更新履歴{' '}
                    </Button>
                  </div>
                </>
              )}
              <div className={classes.moreVertMenuBorder}>
                <Button
                  component={Link}
                  to={{
                    pathname: `/constructions/${constructId}/edit`,
                    state: {
                      state: constructId
                    }
                  }}
                  className={classes.moreVertMenuButton}
                >
                  工事詳細
                </Button>
              </div>
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <div className={classes.moreVertMenuBorder}>
                  <Button
                    component={Link}
                    to={{
                      pathname: '/files',
                      state: {
                        state: { id: constructId, name: constructListVal.label }
                      }
                    }}
                    className={classes.moreVertMenuButton}
                  >
                    資料一覧
                  </Button>
                </div>
              )}
              <div>
                <Button
                  component={Link}
                  to={{
                    pathname: '/pictures',
                    state: {
                      state: { id: constructId, name: constructListVal.label }
                    }
                  }}
                  className={classes.moreVertMenuButton}
                >
                  写真一覧
                </Button>
              </div>
            </div>
          </Popover>
          {/* /三点リーダーメニュー */}
          {/* /レスポンシブレイアウト */}
        </Grid>

        {constructId > 0 && (
          <div className={classes.displayContainer}>
            {/* 工事に紐づく工程が0件の場合 */}
            {!(hasExpectedDays || hasSiteProcess) && (
              <>
                {isSearching && (
                  <div className={classes.loadingContainer}>
                    <LoadingIcon />
                  </div>
                )}
                {!isSearching && (
                  <EmptySiteProcessView
                    constructId={constructId}
                    reRenderSiteProcessData={reRenderSiteProcessData}
                    setHasExpectedDays={setHasExpectedDays}
                    setHasSiteProcess={setHasSiteProcess}
                  />
                )}
              </>
            )}

            {/* 工事期間が存在する場合 */}
            {(hasExpectedDays || hasSiteProcess) && (
              <>
                {displayMode === SITE_PROCESS_DISPLAY_MODE.list && (
                  <SiteProcessListView
                    constructId={constructId}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    renderSiteProcessDataTrigger={renderSiteProcessDataTrigger}
                    reRenderSiteProcessData={reRenderSiteProcessData}
                  />
                )}

                {displayMode === SITE_PROCESS_DISPLAY_MODE.gantt && (
                  <div className={classes.chartContainer}>
                    <SiteProcessGanttView
                      constructId={constructId}
                      setGanttFromTo={setGanttFromTo}
                      isOpenAddSiteProcessModal={isOpenAddOfGantt}
                      setIsOpenAddSiteProcessModal={setIsOpenAddOfGantt}
                      parentSiteProcessId={parentSiteProcessIdOfGanttAdd}
                      setParentSiteProcessId={setParentSiteProcessIdOfGanttAdd}
                      isLoading={isLoadingGantt}
                      setIsLoading={setIsLoadingGantt}
                      reRenderSiteProcessData={reRenderSiteProcessData}
                      isOpenCopy={isOpenCopy}
                      setIsOpenCopy={setIsOpenCopy}
                      isOpenEditPeriod={isOpenEditPeriod}
                      setIsOpenEditPeriod={setIsOpenEditPeriod}
                      isOpenAllDelete={isOpenAllDelete}
                      setIsOpenAllDelete={setIsOpenAllDelete}
                      constructListVal={constructListVal}
                      setHasSiteProcess={setHasSiteProcess}
                    />
                  </div>
                )}

                {/* 工程追加モーダル */}
                <SiteProcessAddModal
                  isOpen={isOpenAdd}
                  setIsOpen={setIsOpenAdd}
                  afterSubmit={reRenderSiteProcessData}
                  constructId={constructId}
                />

                {/* 工程履歴モーダル */}
                <SiteProcessHistoryModal
                  constructId={constructId}
                  isOpen={isOpenSiteProcessHistory}
                  setIsOpen={setIsOpenSiteProcessHistory}
                />
              </>
            )}
          </div>
        )}
      </div>
    </BasePageLayoutWrapper>
  );
};
